import { ProfileForm, ProfileInfoForm } from '../../../screens/edit-profile/types';
import { RUserBody } from '../remote/user';

enum ProfileStep {
    Profile,
    Login
}

const mapProfileInfoFormToUserBody = (
    form: ProfileInfoForm
): Partial<
    Pick<
        RUserBody,
        | 'pronouns'
        | 'title'
        | 'firstname'
        | 'lastname'
        | 'email'
        | 'phone'
        | 'jobTitle'
        | 'motivation'
    >
> => {
    const firstname = form.firstname.value;
    const lastname = form.lastname.value;
    const email = form.email.value;

    if (!firstname || !lastname || !email) {
        throw new Error('Mandatory values are missing in the data you tried to submit!');
    }

    return {
        pronouns: form.pronouns.value ?? null,
        title: form.title.value ?? null,
        firstname: firstname,
        lastname: lastname,
        email: email,
        jobTitle: form.jobTitle.value ?? null,
        phone: form.telephoneNumber.value ?? null,
        motivation: form.motivation.value ?? null
    };
};

export const mapEditUserFormToUserBody = (form: Partial<ProfileForm>): Partial<RUserBody> => {
    const profile =
        form[ProfileStep.Profile] && mapProfileInfoFormToUserBody(form[ProfileStep.Profile]);
    const updatedUser = {
        ...profile
    };

    return updatedUser;
};
